import formAutoTrim from './lib/formAutoTrim'
import { trimString, cancelEvent } from './lib/utils'

try {
  const formEl = document.querySelector('form.acuris-auth-main-form')
  if (formEl) {
    initFormValidation(formEl)
  }
} catch (error) {
  if (console && console.error) {
    console.error(error)
  }
}

/** @param {HTMLFormElement} formEl */
function initFormValidation(formEl) {
  formAutoTrim(formEl)

  /** @type {HTMLButtonElement} */
  const submitBtn = formEl ? formEl.querySelector('input[type=submit]') : null

  /** @type {HTMLInputElement} */
  const emailInput = document.getElementById('email')

  /** @type {HTMLDivElement} */
  const resultElement = document.getElementById('email-validation-result')

  const EMAIL_VALIDATION_PATTERN =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i

  let validationStarted = false

  if (emailInput) {
    emailInput.value = trimString(emailInput.value)

    formEl.addEventListener('submit', onSubmit)

    emailInput.addEventListener('blur', startValidation)
    emailInput.addEventListener('keydown', validate)
    emailInput.addEventListener('keyup', validate)
    emailInput.addEventListener('change', validate)
    emailInput.addEventListener('keypress', validate)

    if (submitBtn) {
      submitBtn.addEventListener('click', onSubmit)
    }
  }

  function startValidation() {
    if (validationStarted || (!validationStarted && trimString(emailInput.value))) {
      validationStarted = true
      validate()
    }
  }

  function onSubmit(event) {
    validationStarted = true

    if (!validate()) {
      return cancelEvent(event)
    }

    return undefined
  }

  function validate() {
    const email = trimString(emailInput.value)
    const valid = email.length > 0 && !!email.match(EMAIL_VALIDATION_PATTERN)

    if (validationStarted && resultElement) {
      if (valid) {
        resultElement.innerHTML = '&nbsp;'
        if (resultElement.style) {
          resultElement.style.visibility = 'hidden'
        }
      } else {
        resultElement.innerHTML = email.length
          ? '<b>Email is invalid, please provide a valid email.</b>'
          : '<b>Email is required.</b>'
        if (resultElement.style) {
          resultElement.style.display = 'block'
          resultElement.style.visibility = 'visible'
        }
      }
    }
    return valid
  }
}
